"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCopyToClipboardButton = exports.StyledIcon = exports.Title = exports.Root = exports.classes = exports.StyledDialog = exports.emailDialogClasses = void 0;
const InputBase_1 = require("@mui/material/InputBase");
const styles_1 = require("@mui/material/styles");
const copy_to_clipboard_button_1 = __importDefault(require("../copy-to-clipboard-button"));
const dialog_1 = __importDefault(require("../dialog"));
const Icon_1 = __importDefault(require("../icon/Icon"));
const typography_1 = __importDefault(require("../typography"));
const EMAIL_DIALOG_PREFIX = "EmailDialog";
exports.emailDialogClasses = {
    input: `${EMAIL_DIALOG_PREFIX}-input`
};
exports.StyledDialog = (0, styles_1.styled)(dialog_1.default)(({ theme }) => ({
    [`.${exports.emailDialogClasses.input}`]: {
        marginTop: "1rem"
    },
    [`.${InputBase_1.inputBaseClasses.root}`]: {
        backgroundColor: theme.colours.white
    }
}));
const PREFIX = "ShareWidget";
exports.classes = {
    iconList: `${PREFIX}-iconList`,
    leftAligned: `${PREFIX}-leftAligned`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    alignItems: "center",
    color: theme.colours.slate,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    paddingTop: "16px",
    [`.${exports.classes.iconList}`]: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-end",
        listStyle: "none",
        margin: "0 0 16px",
        paddingLeft: 0
    },
    [`&.${exports.classes.leftAligned}`]: {
        justifyContent: "flex-start",
        [`.${exports.classes.iconList}`]: {
            justifyContent: "flex-start"
        }
    }
}));
exports.Title = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    margin: "0 24px 16px 0",
    color: theme.colours.charcoal
}));
exports.StyledIcon = (0, styles_1.styled)(Icon_1.default)(({ theme }) => ({
    fill: theme.colours.slate
}));
exports.StyledCopyToClipboardButton = (0, styles_1.styled)(copy_to_clipboard_button_1.default)(({ theme }) => ({
    "&, & path": { fill: theme.colours.slate }
}));
//# sourceMappingURL=data:application/json;base64,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